import { Endpoints } from "../endpoints";

export function formatRotationDate(value, locales = navigator.languages) {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat(locales, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    calendar: "gregory",
    numberingSystem: "latn",
  }).formatToParts(date);
  const fields = parts.filter(({ type }) => ["day", "month", "year"].includes(type));
  const day = fields.find(({ type }) => type === "day").value;
  const month = fields.find(({ type }) => type === "month").value;
  const year = fields.find(({ type }) => type === "year").value;
  return fields[0].type === "month" ? `${month}/${day}/${year}` : `${day}/${month}/${year}`;
}

let pending;

export function getNewArrivalsDate() {
  if (!pending) {
    pending = fetch(Endpoints.newArrivals())
      .then((response) => response.ok ? response.json() : null)
      .then((data) => formatRotationDate(data && data.rotatedAt))
      // Optional homepage metadata must not prevent navigation when unavailable.
      .catch(() => formatRotationDate())
      .finally(() => { pending = null; });
  }
  return pending;
}
